/**
 * The hero's painted background: three blurred blobs, three stacked wave paths and a diagonal
 * sheen. It carries no text and no controls, so it is hidden from assistive technology entirely.
 */
export function HeroBackdrop() {
    return (
        <div className="hero-bg">
            <div className="wave-shape wave-1" />
            <div className="wave-shape wave-2" />
            <div className="wave-shape wave-3" />
            <svg
                className="hero-waves"
                preserveAspectRatio="none"
                viewBox="0 0 1440 900"
                fill="none"
                aria-hidden="true"
            >
                <path
                    d="M-200 200 C 350 50, 800 300, 1300 100 S 1900 200, 1900 400 L 1900 1200 L -200 1200 Z"
                    fill="oklch(1 0 0 / 0.22)"
                />
                <path
                    d="M-200 380 C 300 230, 750 480, 1200 280 S 1850 380, 1850 580 L 1850 1300 L -200 1300 Z"
                    fill="oklch(0.25 0.05 195 / 0.35)"
                />
                <path
                    d="M-200 560 C 250 410, 700 660, 1100 460 S 1750 560, 1750 760 L 1750 1400 L -200 1400 Z"
                    fill="oklch(1 0 0 / 0.15)"
                />
            </svg>
            <div className="hero-sheen" />
        </div>
    );
}
